import * as React from 'react';
import * as styles from './Description.css';

interface IDescriptionMarkupProps {
  html: string;
}

export const DescriptionMarkup: React.FC<IDescriptionMarkupProps> = ({ html }) => {
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: html as string }} className={styles['markup']} />;
};
